import { ApiProvider } from "@src/store/ApiProvider";
import { getThunkAndSlice } from "@src/store/getThunkAndSlice";
import { handlePasswordManagerUnauthorized } from "./passwordManagerUnauthorized";

export interface ICredential {
	credentialId: number;
	companyName: string;
	companyId: number;
	vendorName: string;
	vendorId: number;
	username: string;
	notes: string | null;
	teamCode: string | null;
	loginLock: boolean;
	verificationCode: string | null;
	lastUpdatedDate: string | null;
	lastUpdatedUser: string | null;
	errorMessage: string | null;
	created: boolean;
	updated: boolean;
	onboarded?: boolean | null;
	subscribed?: boolean | null;
	syncAccountId: number | null;
	tradeDeskAccountCreatedDate: string | null;
	tradeDeskAccountUpdatedDate: string | null;
	lastVerifiedDate: string | null;
	isValid: boolean | null;
	notificationEmail: string | null;
	enableNotifications: boolean;
}

export interface IGetCredentialsParams {
	page?: number;
	pageSize?: number;
	sortBy?: string;
	sortDirection?: string;
	search?: string;
	companyId?: string | number;
	username?: string;
	vendorId?: string | number;
	onboarded?: boolean | null;
	subscribed?: boolean | null;
	isValid?: "valid" | "invalid" | "not_checked" | null;
}

export interface IGetCredentialsResponse {
	data: Array<ICredential>;
	totalCount: number;
	pageSize: number;
	currentPage: number;
	totalPages: number;
}

const initialState: IGetCredentialsResponse = {
	data: [],
	totalCount: 0,
	pageSize: 0,
	currentPage: 0,
	totalPages: 0,
};

const credentialsPath = "/passwordManager/Credentials";

const buildExternalUrl = (params: IGetCredentialsParams) => {
	const baseUrl = ApiProvider.default.passwordManagerBaseURL || "https://qa.stagefront.com/password-manager/api";
	const searchParams = new URLSearchParams();

	searchParams.set("page", String(params.page ?? 1));
	searchParams.set("pageSize", String(params.pageSize ?? 50));
	if (params.sortBy) searchParams.set("sortBy", params.sortBy);
	if (params.sortDirection) searchParams.set("sortDirection", params.sortDirection);
	if (params.search) searchParams.set("search", params.search);
	if (params.companyId !== undefined && params.companyId !== null && params.companyId !== "") {
		searchParams.set("companyId", String(params.companyId));
	}
	if (params.username) searchParams.set("username", params.username);
	if (params.vendorId !== undefined && params.vendorId !== null && params.vendorId !== "") {
		searchParams.set("vendorId", String(params.vendorId));
	}
	if (params.onboarded !== null && params.onboarded !== undefined) {
		searchParams.set("onboarded", String(params.onboarded));
	}
	if (params.subscribed !== null && params.subscribed !== undefined) {
		searchParams.set("subscribed", String(params.subscribed));
	}
	if (params.isValid !== null && params.isValid !== undefined) searchParams.set("isValid", String(params.isValid));

	return `${baseUrl.replace(/\/$/, "")}/Credentials?${searchParams.toString()}`;
};

const getAuthHeaders = () => {
	const token = localStorage.getItem("PasswordManager_accessToken") ?? "";
	return {
		Authorization: token ? `Bearer ${token}` : undefined,
		passwordManagerAccessToken: token || undefined,
	};
};

export const { thunk: getCredentials, slice: credentialsSlice } = getThunkAndSlice<
	IGetCredentialsParams,
	IGetCredentialsResponse,
	IGetCredentialsResponse
>({
	initialState,
	path: credentialsPath,
	externalPath: buildExternalUrl,
	getHeaders: getAuthHeaders,
	onUnauthorized: handlePasswordManagerUnauthorized,
});
